import React from 'react';
import {Platform, ScrollView, View, SafeAreaView, TouchableOpacity, StyleSheet, Linking} from 'react-native';
import {hocComponentFetcherWithLoader} from '../../components';
import CustomText from '../../components/customText';
import Text from '../../components/customText';
import Header from '../../components/Header/Header';
import TickerComponent from '../../components/tickerComponent';
import {isWeb} from '../../components/Header/HeaderCommons';
import KeyboardAwareScrollView from '../../components/keyboardAwareScrollView';
import {stickyFooterStyle} from '../../styles/stickyHeaderandFooterStyle';
import Footer from '../../components/customFooter';
import style from './uploadDocStyle';
import {getResponsiveStyle} from '../../utils/appUtils';
import OrangeButton from '../../components/customLinearOrangeButton';
import { responsiveWidth } from '../../components/customResponsiveDimension';
import CustomOrangeButton from '../../components/customLinearOrangeButton';

const styles = StyleSheet.create({
  subContainerStyle: {
    paddingTop: '5%',
    paddingBottom: Platform.OS === 'web' ? '0%' : '5%',
    flexDirection: 'column',
    flex: 0.7,
    paddingLeft: responsiveWidth(10)
  },
  subContainerStyle_XXXHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(12)
  },
  subContainerStyle_XXHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(12)
  },

  subContainerStyle_XHDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  subContainerStyle_HDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3)
  },
  subContainerStyle_MDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3),
    paddingTop: '10%',
    paddingLeft: 5,
    paddingRight: 5
  },
  subContainerStyle_LDPI: {
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 0,
    marginHorizontal: responsiveWidth(3),
    paddingTop: '10%',
    paddingLeft: 5,
    paddingRight: 5
  },
  button: {
    width: '100%',
    paddingLeft: '0%',
    paddingRight: '75%',
    paddingTop: '5%',
    paddingBottom: '5%'
  },
  button_LDPI: {
    paddingLeft: '0%',
    paddingRight: '30%',
    marginTop: '5%'
  },
  button_MDPI: {
    paddingLeft: '0%',
    paddingRight: '45%',
    marginTop: '5%'
  },
  button_HDPI: {
    paddingLeft: '0%',
    paddingRight: '60%'
  },
  button_XHDPI: {
    paddingLeft: '0%',
    paddingRight: '70%'
  },
  button_XXHDPI: {
    paddingLeft: '0%',
    paddingRight: '70%'
  },
  button_XXXHDPI: {
    paddingLeft: '0%',
    paddingRight: '20%'
  }
});

class VerificationBusiness extends React.Component {
  constructor(props) {
    super(props);
    //   const {makeAPICall} = props;
    //   this.makeAPICall = makeAPICall;
    this.state = {};
  }
  navigateToBankAccount = () => {
    const {navigation} = this.props;
    navigation.navigate('ManageMyAccounts', {fromdoc: 'docsupload'});
  };

  render() {
    const {measure,navigation} = this.props;
    const styleWidth = measure;

    // console.log("good");
    
    return (
      <SafeAreaView style={{flex: 1}}>
        <KeyboardAwareScrollView>
          <View style={{flex: 1}}>
            {/* <ScrollView
              style={{backgroundColor: '#FCFCFC'}}
              ref={scroller => {
                this.scroller = scroller;
              }}> */}
              <Header {...this.props} />
              {Platform.OS !== 'web' ? <TickerComponent {...this.props} /> : null}
              {Platform.OS === 'web' ? (
                <View
                  style={{
                    backgroundColor: '#182340',
                    // shadowColor: '#000000',
                    paddingHorizontal: '1.5%',
                    height: 64,
                    justifyContent: 'center'
                  }}>
                  <Text style={[style.subHeaderStyle, style[getResponsiveStyle('subHeaderStyle', measure)]]}>Verification Page</Text>
                </View>
              ) : null}
              <View style={style.containerStyle}>
                <View style={[styles.subContainerStyle, styles[getResponsiveStyle('subContainerStyle', measure)]]}>
               <Text
    style={{
      fontSize: 16,
      color: '#4a4a4a',
      width: '100%',
      lineHeight: 20,
      textAlign: 'center',
    }}>
    Thank you for submitting the requested documents for your Money2India business account. The documents are being reviewed by our team and may take upto 3 business days. For further assistance, please contact us at +1 (646) 827-8450 or email us at{' '}
    <Text
      style={{
        fontSize: 16,
        color: '#007bff',
        textDecorationLine: 'underline',
      }}
      onPress={() => {
        Linking.openURL('mailto:moneytoindia@icicibank.com').catch(err =>
          console.error('Failed to open email client', err)
        );
      }}>
      moneytoindia@icicibank.com
    </Text>.
  </Text>

  {Platform.OS==="ios" &&
  <CustomOrangeButton onPress={() => navigation.navigate('SendMoneyForRegUser')}>Back to Home</CustomOrangeButton>}
                  {/* <Text
                    style={{
                      fontSize: 16,
                      color: '#4a4a4a',
                      width: '100%',
                      marginTop: '3%',
                      lineHeight: 20
                    }}>
                    You will receive an email, once your documents are verified.
                  </Text> */}
                  {/* <Text
                    style={{
                      fontSize: 16,
                      color: '#4a4a4a',
                      width: '100%',
                      marginTop: '3%'
                    }}>
                    Please proceed to add your overseas Bank Account.
                  </Text>
                  <View style={[styles.button, styles[getResponsiveStyle('button', styleWidth)]]}>
                    <TouchableOpacity onPress={() => this.navigateToBankAccount()}>
                      <OrangeButton style={{fontSize: 16}} styleDisabled={{color: 'white'}} onPress={() => this.navigateToBankAccount()}>
                        Add Bank Account
                      </OrangeButton>
                    </TouchableOpacity>
                  </View> */}
                </View>
              </View>

              {Platform.OS === 'web' ? <View style={{height: this.state.dummyViewHeight}}></View> : null}
            {/* </ScrollView> */}
          </View>

          {Platform.OS === 'web' ? (
            <div style={stickyFooterStyle()}>
              <View onLayout={() => this.onLayoutFooter}>
                <Footer {...this.props} />
              </View>
            </div>
          ) : null}
        </KeyboardAwareScrollView>
      </SafeAreaView>
    );
  }
}

export default hocComponentFetcherWithLoader()(VerificationBusiness);